const searchParams = new URLSearchParams(window.location.search);
const pageSize = searchParams.get('pageSize');
const pageNumber = searchParams.get('pageNumber');
export const OrderInitialState = {
	orderActivityLogLists: { activityCategories: [], informationLevels: [] },
	isOrderActivityLogListsLoading: false,
	orderActivityLogData: [],
	enableArchiveSearch: false,
	isOrderActivityLogDataLoading: false,
	reportTypesList: [],
	isReportListLoading: false,
	isSendingReport: false,
	orderData: null,
	orderTotalItemCount: 0,
	isOrderDataLoading: true,
	orderStatuses: [],
	dashboardData: {},
	isDashboardDataLoading: false,
	orderDetailsData: null,
	isOrderDetailsDataLoading: true,
	activityLogList: null,
	activityLogTotalItemCount: 0,
	activityLogTablePageSize: 10,
	activityLogTablePageNumber: 0,
	isActivityLogListLoading: false,
	isSettlementsDetailsExportLoading: false,

	isRefundItemsLoading: false,
	reportCache: {},
	isCancelOrderLoading: false,
	isExportCSVLoading: false,
	isOrderStatusesLoading: false,
	partnersCommissions: [],
	isPartnersCommissionsLoading: false,
	partnersCommissionsById: null,
	isPartnersCommissionsByIdLoading: false,
	partnersCommissionsDetails: [],
	isPartnersCommissionsDetailsLoading: false,
	agenciesCommissions: [],
	isAgenciesCommissionsLoading: false,
	agenciesCommissionsById: null,
	isAgenciesCommissionsByIdLoading: false,
	agenciesCommissionsDetails: [],
	isAgenciesCommissionsDetailsLoading: false,
	fundsReserveList: [],
	isFundsReserveListLoading: true,
	fundsReserveListTotalItemCount: 0,
	fundsReserveListTablePageSize: 500,
	fundsReserveListTablePageNumber: 0,
	fundsReserveListDetails: [],
	isFundsReserveListDetailsLoading: false,
	fundsReserveListDetailsTotalItemCount: 0,
	fundsReserveListDetailsTablePageSize: 10,
	fundsReserveListDetailsTablePageNumber: 0,

	pageNumber: Number(pageNumber) ? Number(pageNumber) - 1 : 0,
	pageSize: Number(pageSize) || 10,

	status: [],
	pid: '',
	timezone: 'UTC',
	sid: '',
	externalOrderId: '',
	orderId: '',
	email: '',
	firstName: '',
	lastName: '',
	bin: '',
	last4: '',
	isMIT: '',
	placedFrom: '',
	placedTo: '',
	from: '',
	to: '',
	query: '',
	orderFavoriteFilters: [],
	orderSorting: [],

	orderLinks: [],
};
